import {
  LayoutDashboard,
  FileText,
  Globe,
  Server,
  Map,
  Lightbulb,
  ListTodo,
  Network,
  Eye,
  Settings,
  DollarSign,
  BookOpen,
  Zap,
  Cloud,
  Route,
  Layers,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  title: string;
  url: string;
  icon: LucideIcon;
  disabled?: boolean;
}

export interface NavGroup {
  label?: string;
  items: NavItem[];
}

export const navigation: NavGroup[] = [
  {
    items: [
      {
        title: "Panel glowny",
        url: "/",
        icon: LayoutDashboard,
      },
    ],
  },
  {
    label: "TRESC",
    items: [
      {
        title: "Mapy Tematyczne",
        url: "/mapy-tematyczne",
        icon: Network,
      },
      {
        title: "Auto-generuj mapy",
        url: "/mapy-tematyczne/auto-generate",
        icon: Zap,
      },
      // Standalone Mode (Artykuły) — za feature flagą VITE_STANDALONE_MODE_ENABLED
      ...(import.meta.env.VITE_STANDALONE_MODE_ENABLED === "true"
        ? [{
            title: "Artykuly",
            url: "/artykuly",
            icon: FileText,
          }]
        : []),
      {
        title: "Mapa Wizualna",
        url: "/mapa-wizualna",
        icon: Eye,
      },
      // Migracja WP -> Cloudflare Pages: lista domen + Studio per domena (2026-09-22)
      {
        title: "Strony statyczne",
        url: "/strony",
        icon: Layers,
      },
    ],
  },
  {
    label: "INFRASTRUKTURA",
    items: [
      {
        title: "Domeny",
        url: "/domains",
        icon: Globe,
      },
      {
        title: "Hostingi",
        url: "/hostings",
        icon: Server,
      },
      {
        title: "Mapa Stron",
        url: "/sitemap",
        icon: Map,
      },
      {
        title: "Cloudflare",
        url: "/cloudflare",
        icon: Cloud,
      },
      {
        title: "Zmiana DNS",
        url: "/dns",
        icon: Route,
      },
    ],
  },
  {
    label: "KOMUNIKACJA",
    items: [
      {
        title: "Pomysly",
        url: "/pomysly",
        icon: Lightbulb,
      },
      {
        title: "Taski",
        url: "/taski",
        icon: ListTodo,
      },
    ],
  },
  {
    label: "USTAWIENIA",
    items: [
      {
        title: "Koszty API",
        url: "/koszty-api",
        icon: DollarSign,
      },
      {
        title: "Dokumentacja",
        url: "/docs",
        icon: BookOpen,
      },
      {
        title: "Ustawienia",
        url: "/ustawienia",
        icon: Settings,
      },
    ],
  },
];
